import React from "react";
import {getUserName, getUserPhoneNumber} from "../../../helpers/authenticator";

const Profile = () => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-md-7">
                    <div className="default-profile-img">
                    </div>
                    <ul className="list-unstyled text-center">
                        <li>
                            <p>{getUserName()}</p>
                        </li>
                        <li><p>{getUserPhoneNumber()}</p></li>
                        <li className="text-left"><small>Full name</small></li>
                        <li>
                            <div className="input-group">
                                <input type="text" className="form-control form-control-lg input-form-alt"
                                       placeholder="Full name"
                                       aria-label="Username" aria-describedby="basic-addon1"/>
                            </div>
                        </li>
                        <li className="text-left"><small>Password</small></li>
                        <li>
                            <div className="input-group">
                                <input type="password" className="form-control form-control-lg input-form-alt"
                                       placeholder="Password"
                                       aria-label="Username" aria-describedby="basic-addon1"/>
                            </div>
                        </li>
                        <li>
                            <p className="text-left small-text-blue text-right">
                                Update
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
};
export default Profile;
